import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 20px;
  padding-left: 60px;
`;
